import { getApi, postApi } from "./apiService";

export const createMerchant = async (merchantData) => {
  return await postApi("/mp/user/register", merchantData);
};

export const loginMerchant = async (merchantData) => {
  return await postApi("/mp/user/login", merchantData)
}

export const forgotPassword = async (body) => {
  return await postApi("/mp/user/forgot-password", body)
}

export const resetPassword = async (body) => {
  return await postApi("/mp/user/reset-password", body)
}

export const merchantProfile = async (body) => {
  return await getApi("/mp/user/merchant-profile")
}